import {Box} from "@mui/material";
import Sidebar from "./sidebar/Sidebar";
import {DrawerHeaderStyled} from "./sidebar/SidebarStyles";
import PropTypes from "prop-types";
import Toolbar from "./toolbar/Toolbar";
import {useState} from "react";

const Navigation = ({children}) => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [isClosing, setIsClosing] = useState(false);

    const handleSidebarToggle = () => {
        if (!isClosing) {
            setSidebarOpen(!sidebarOpen);
        }
    };

    return (
        <Box sx={{display: 'flex'}}>
            <Toolbar handleSidebarToggle={handleSidebarToggle}/>
            <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} setIsClosing={setIsClosing}/>
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    p: 5,
                    overflowX: 'auto',
                }}
            >
                <DrawerHeaderStyled/>
                {children}
            </Box>
        </Box>
    )
};

Navigation.propTypes = {
    children: PropTypes.node.isRequired,
};

export default Navigation;